export default __webpack_public_path__ + "static/media/RocketRinder.46eb02aa.otf";